export default function (state, newRule) {
  const localState = {...state}

  const newFilterRules = localState.filterRules.filter(rules => rules.rule !== newRule.rule)

  if (newFilterRules.length < state.filterRules.length) {
    return {
      ...state,
      filterRules: newFilterRules,
    }
  }

  return {
    ...state,
    filterRules: [...state.filterRules, newRule],
  }
}
